import React, { ReactElement, useState } from 'react';
import { SearchResults, SingleSelect } from 'idsk-react-components';
import { ExpansionPanel } from 'slovlex-idsk-react-components';
import { SafeParameterSetter } from '../../../../types/SafeParameterSetter';
import { SubjectItem } from '../../../../model/legislativnyMaterial/SubjectItem';
import LegMaterialListFilter from '../../../../model/legislativnyMaterial/LegMaterialListFilter';
import useSearchOrganizacie from '../hooks/useSearchOrganizacie';
import {
  MAX_MULTISELECT_RESULT,
  SHOW_ALL_MAX_RESULT,
} from '../../../../constants/MultiSelectConstant';

interface Props {
  filterCopy: LegMaterialListFilter;
  filter: LegMaterialListFilter;
  onUpdateField: SafeParameterSetter<LegMaterialListFilter>;
  onUpdateFieldCopy: SafeParameterSetter<LegMaterialListFilter>;
  isExpanded?: boolean;
}

const InstituciaSingleSelect = ({
  filterCopy,
  filter,
  onUpdateField,
  onUpdateFieldCopy,
  isExpanded = !!filter.institucia,
}: Props): ReactElement => {
  const [searchText, setSearchText] = useState('');
  const [showList, setShowList] = useState<boolean>(false);
  const [limit, setLimit] = useState(MAX_MULTISELECT_RESULT);
  const [execute, setExecute] = useState(!!filter.institucia);

  const {
    organizacie,
    organizacieStatus,
  } = useSearchOrganizacie(
    {
      typ: undefined,
      ids: [],
      ldap: true,
      legislativna: true,
      platna: undefined,
      nazov: filterCopy?.institucia?.nazov || searchText,
      limit,
      execute,
    },
  );

  const handleSelectedItemChange = (item: SubjectItem): void => {
    setShowList(false);
    if (item) {
      onUpdateField('institucia', item);
    } else {
      onUpdateFieldCopy('institucia', item);
    }
  };

  return (
    <ExpansionPanel
      title="Zodpovedná inštitúcia"
      isExpanded={isExpanded}
      onExpand={() => setExecute(true)}
    >
      <div className="single-select-input-wrapper">
        <SingleSelect
          id="zodpovednaInstituciaSingleSelect"
          name="zodpovednaInstituciaSingleSelect"
          searchText={searchText}
          setSearchText={(text) => {
            setSearchText(text);
            setLimit(MAX_MULTISELECT_RESULT);
          }}
          selectedItem={filterCopy.institucia || null}
          setSelectedItem={handleSelectedItemChange}
          selectedItemValue={filter.institucia?.nazov || ''}
          visibilityMinSearchLength={0}
          showList={showList}
          setShowList={setShowList}
          aria-label="Zodpovedná inštitúcia"
        />
        <SearchResults
          loadingShowAll={organizacieStatus.loading}
          className="single-select-fazet"
          handleShowAll={() => {
            setLimit(SHOW_ALL_MAX_RESULT);
          }}
          withShowAllButton={(limit === MAX_MULTISELECT_RESULT
                && organizacie.length === MAX_MULTISELECT_RESULT)
              || (limit === SHOW_ALL_MAX_RESULT && organizacie.length <= MAX_MULTISELECT_RESULT)}
          setSearchText={(text) => {
            setSearchText(text);
            setLimit(MAX_MULTISELECT_RESULT);
          }}
          data={organizacie}
          setSelectedItem={handleSelectedItemChange}
          dataAttributesToShow={[{ key: 'nazov', label: '' }]}
          type="column"
          size="m"
          visible={searchText.trim().length > 0 || showList}
        />
      </div>
    </ExpansionPanel>
  );
};

export default InstituciaSingleSelect;
